import { AppState } from "@Store/index";
import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchAmberPLusPageDataIfNeeded } from "./data/amberPlusPageReducer";
import { RouteComponentProps } from "react-router";
import useIsApp from "hooks/useIsApp";

const useAmberPlus = (props: RouteComponentProps) => {
  const dispatch = useDispatch();
  const isApp = useIsApp();
  const { isError, isStatus500 } = useSelector(
    ({ amberPlusPageData }: AppState) => ({
      isError: amberPlusPageData.readyStatus === "failure",
      isStatus500: !JSON.stringify(amberPlusPageData.error)?.includes("404"),
    }),
    shallowEqual,
  );

  useEffect(() => {
    dispatch(fetchAmberPLusPageDataIfNeeded({ ...props, isApp }));
  }, [dispatch]);

  return {
    isError,
    isStatus500,
  };
};

export default useAmberPlus;
